import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

const PAGES = [
  { key: "library", to: "/library" },
  { key: "journal", to: "/journal" },
  { key: "about", to: "/about" },
];

export default function Footer() {
  const { t } = useLang();
  const c = t.contact;

  return (
    <footer className="bg-noir text-paper">
      {/* Contact — discreet, no form */}
      <section id="contact" className="px-6 md:px-12 lg:px-20 pt-28 md:pt-40 pb-20 md:pb-28">
        <div className="eyebrow text-paper/50 mb-8">{c.label}</div>
        <p
          data-testid="contact-dialogue"
          className="serif italic text-2xl md:text-4xl lg:text-5xl leading-[1.18] text-paper/90 max-w-4xl break-words"
        >
          {c.dialogueLabel}:{" "}
          <a
            href={`mailto:${c.email}`}
            data-cursor="link"
            data-testid="contact-email-link"
            className="not-italic font-display link-underline hover:opacity-70 transition-opacity"
          >
            {c.email}
          </a>
        </p>
      </section>

      {/* Footer bar */}
      <div className="px-6 md:px-12 lg:px-20 py-10 border-t border-white/10 flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div>
          <div className="display text-2xl leading-none">Oana <span className="serif italic font-normal">Mudura</span></div>
          <div className="eyebrow text-paper/40 mt-2">{t.footer.tagline}</div>
        </div>
        <nav className="flex flex-wrap gap-x-8 gap-y-2">
          {PAGES.map((p) => (
            <Link key={p.key} to={p.to} data-cursor="link" className="eyebrow text-paper/60 hover:text-paper transition-colors">
              {t.nav[p.key]}
            </Link>
          ))}
        </nav>
        <div className="eyebrow text-paper/40 flex flex-col md:items-end gap-1">
          <span>{t.footer.city}</span>
          <span>
            © {new Date().getFullYear()} · {t.footer.rights} ·{" "}
            <Link to="/admin" className="hover:text-paper transition-colors">{t.footer.admin}</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
